import { useCallback, useState } from 'react'
import { useFormContext } from 'react-hook-form'

type PasswordType = {
  id?: 'password' | 'passwordReInput'
  label?: string
  require?: boolean
  minLength?: number
  validate: Record<string, (value: string) => boolean | string>
  placeholder?: string
}

const Password = (props: PasswordType) => {
  const {
    id = 'password',
    label = 'パスワード',
    require = true,
    minLength = 0,
    validate,
    placeholder = '',
  } = props

  const {
    register,
    formState: { errors },
  } = useFormContext()

  const [typeState, setTypeState] = useState<'password' | 'text'>('password')

  const togglePasswordShow = useCallback(() => {
    if (typeState === 'password') {
      setTypeState('text')
    } else {
      setTypeState('password')
    }
  }, [typeState])

  return (
    <div className="relative">
      <label
        htmlFor={`${id}`}
        className="text-gray-600 mt-3 block text-sm font-bold uppercase"
      >
        {label}
        {require ? '*' : ''}
      </label>
      <div className="relative">
        <input
          aria-label={`${label}`}
          id={`${id}`}
          type={typeState}
          name={`${id}`}
          placeholder={placeholder}
          autoComplete={`${id}`}
          className="c-input c-placeholder_text-size"
          {...register(`${id}`, {
            // pattern,
            validate: validate,
            minLength,
            required: true,
          })}
        />
        <div
          className="absolute top-[50%] right-[10px] h-[16px] w-[20px] -translate-y-2/4 "
          onClick={() => {
            togglePasswordShow()
          }}
        >
          {typeState === 'password' ? (
            <img
              src={`${process.env.NEXT_PUBLIC_SITEURL}/${process.env.NEXT_PUBLIC_SERVICE_NAME}/images/common/icon/eye-slash-solid.svg`}
              alt=""
            />
          ) : (
            <img
              src={`${process.env.NEXT_PUBLIC_SITEURL}/${process.env.NEXT_PUBLIC_SERVICE_NAME}/images/common/icon/eye-solid.svg`}
              alt=""
            />
          )}
        </div>
      </div>

      {id === 'password' && (
        <>
          <p className="text-xs text-color01">
            ※半角英数字8文字以上でご入力ください
          </p>
          {errors.password?.type === 'e' && (
            <p className="error text-xs text-color01">
              {errors.password?.message}
            </p>
          )}
          {errors.password?.type === 'p' && (
            <p className="error text-xs text-color01">
              {errors.password?.message}
            </p>
          )}
          {errors.password?.type === 'minLength' && (
            <p className="error text-xs text-color01">
              ※8桁以上でご入力ください。
            </p>
          )}
          {errors.password?.type === 'required' && (
            <p className="error text-xs text-color01">※入力してください</p>
          )}
        </>
      )}

      {id === 'passwordReInput' && (
        <>
          {errors.passwordReInput?.type === 'comfirm' && (
            <p className="error text-xss text-color01">
              {errors.passwordReInput.message}
            </p>
          )}
        </>
      )}
    </div>
  )
}

export default Password
